import type { FaireProductEntity } from "../../entity_types/product";

export const p_q6ueeg7gux: FaireProductEntity = {
  token: "p_q6ueeg7gux",
  type: "product",
  name: "Farmhouse - Candle",
  brandName: "Soy Harvest Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/bf81b829ac224b2489883d45b271d8566c9f34875bdf5d1d4b6cf6f55ffaeb0a.png",
  priceDollars: 12,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6caf2a6699133220a3d3483397a10761bb59889a57839ee9ee7ce2d38b72c79b.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
